import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { EmployeeUpdatePayload } from 'api/services/workforce/workforce-service.types';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

type EmployeeMutationOptions = UseMutationOptions<string, unknown, EmployeeUpdatePayload>;

export const useUpdateEmployee = (employeeId: string, options?: EmployeeMutationOptions) => {
  const mutationFn = async (employee: EmployeeUpdatePayload) =>
    await sharedWorkforceService.updateEmployee(employeeId, employee);

  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: EmployeeMutationOptions = {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.all());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};
